<template>
    <default-modal
        ref="box"
        :title="title"
        :modalWidth="600"
        :confirmBtn="false"
    >
        <div class="modal-body">
            <div class="row">
                <span
                    class="left"
                    style="height: 32px;
                    line-height: 32px;"
                    >请选择文件：</span
                >
                <div class="right">
                    <file-upload
                        ref="fileUpload"
                        :format="['dfd']"
                        :size="125"
                        :url="$HTTP_API.securityCenter.importFile"
                        @fileResult="fileResult"
                    ></file-upload>
                </div>
            </div>
            <div class="row">
                <span class="left">导入状态：</span>
                <div class="right">
                    <div>尚未选择规则/规则文件格式错误/规则无法识别</div>
                    <div>规则ID-规则名可以使用</div>
                    <div>
                        规则导入平台并将规则应用到安全组后，网吧端即可生效。
                    </div>
                </div>
            </div>
        </div>
    </default-modal>
</template>
<script>
import DefaultModal from "_c/modals/defaultModal";
import FileUpload from "_c/uploadFile"; // 引入上传文件组件
export default {
    components: {
        DefaultModal,
        FileUpload,
    },
    data() {
        return {
            ruleId: "",
            ruleName: "",
            title: "导入规则",
            successFn: "",
        };
    },
    mounted() {
        window.$modal.importRule = {};
        window.$modal.importRule.show = () => {
            return new Promise((resolve) => {
                this.init(() => {
                    resolve(true);
                });
            });
        };
    },
    methods: {
        // 初始化信息
        init(fn) {
            this.$refs.box.show();
            this.successFn = fn;
        },
        fileResult() {
            this.$refs.box.hide();
            this.successFn();
        },
    },
};
</script>
<style lang="scss" scoped>
.modal-body {
    padding: 10px 0 10px 50px;
    text-align: left;
    .row {
        overflow: hidden;
        margin-bottom: 10px;
        .left {
            width: 75px;
            text-align: right;
        }
        .left,
        .right {
            float: left;
        }
    }
}
</style>
